import { toast } from "react-toastify";
import { FETCH_PACKAGE_DETAILS, FETCH_HISTORY_DETAILS, UPDATE_SELECTED_PACKAGE, PROPATED_PRICE } from "../actions/subscriptionAction";
import { isFulfilled, isPending, isRejected } from "./reducerUtils";

const initialState = {
    packages: {},
    history: [],
    packageSelected: null,
    proratedLoading: false,
    proratedPrice: null,
};

const subscriptionReducer = (state = initialState, action) => {
    switch (action.type) {
        case isFulfilled(FETCH_PACKAGE_DETAILS): {
            const packages = {};
            let newPriceArr = [
                "price_1M50VcBbiCeiSCMeX8sL03As",
                "price_1M7ByrBbiCeiSCMeGBNtK3Ko",
                "price_1M7BtbBbiCeiSCMeAuIrzRHb",
                "price_1M7BzFBbiCeiSCMeokOGTCh0",
                "price_1M7BvbBbiCeiSCMeZU5g9QjT",
                "price_1M7BzVBbiCeiSCMerxL52GUN",
                "price_1M7Bw2BbiCeiSCMel7U2k80d",
                "price_1M7BzjBbiCeiSCMepzKiVjaC",
            ];

            if (action.payload) {
                action.payload.forEach((p) => {
                    if (!p.metadata.package_code) return;
                    if (newPriceArr.includes(p.id)) {
                        if (!packages[p.metadata.package_code]) packages[p.metadata.package_code] = {};
                        packages[p.metadata.package_code][p.recurring.interval] = { id: p.id, unit_amount: p.unit_amount / 100, productId: p.product.id };
                    }
                });
            }
            return { ...state, packages };
        }

        case isFulfilled(FETCH_HISTORY_DETAILS): {
            return { ...state, history: action.payload };
        }
        case UPDATE_SELECTED_PACKAGE: {
            return { ...state, packageSelected: action.payload };
        }
        case isPending(PROPATED_PRICE): {
            return { ...state, proratedLoading: true, proratedPrice: null };
        }
        case isFulfilled(PROPATED_PRICE): {
            if (action.payload?.status === "error") {
                toast.error("Some error occured while getting the prices for subscription");
                return { ...state, proratedLoading: false, proratedPrice: null };
            }

            return { ...state, proratedLoading: false, proratedPrice: action.payload };
        }
        default:
            return state;
    }
};

export default subscriptionReducer;
